module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity/brag/brag-07-d104a7b5e4358509d670db3e4294f271.jpg";